// schemas/auth.schema.ts
import { z } from 'zod';

// ── Request (POST payload) ──────────────────────────────
export const LoginSchema = z.object({
  email: z.string().email({ message: 'Email tidak valid!' }),
  password: z.string().min(4, { message: 'Password minimal 4 karakter!' }),
});

export type LoginPayload = z.infer<typeof LoginSchema>;

// ── Response (API shape → transform to DTO) ─────────────
const LoginUserApiSchema = z
  .object({
    id_user: z.string(),
    full_name: z.string(),
    email: z.string(),
  })
  .transform(raw => ({
    idUser: raw.id_user,
    fullName: raw.full_name,
    email: raw.email,
  }));

const LoginResultSchema = z
  .object({
    access_token: z.string(),
    refresh_token: z.string(),
    user: LoginUserApiSchema,
  })
  .transform(raw => ({
    accessToken: raw.access_token,
    refreshToken: raw.refresh_token,
    user: raw.user,
  }));

const LoginApiSchema = z
  .object({
    result: LoginResultSchema,
  })
  .transform(raw => raw.result);

// Inferred DTO types (camelCase — what your UI uses)
export type LoginDTO = z.infer<typeof LoginApiSchema>;
export type LoginUserDTO = z.infer<typeof LoginUserApiSchema>;

export function toLoginDTO(raw: unknown): LoginDTO {
  return LoginApiSchema.parse(raw);
}
